import { Form } from "antd";

import ExportButton from "./ExportButton";
import FilterSelect from "./FilterSelect";
import { useFilters } from "./hooks/useFilters";

const ExportIntervention = () => {
  const [params, setFilters] = useFilters();
  return (
    <Form layout="vertical">
      <FilterSelect
        model="interventions"
        onChange={(value) => setFilters("id", value)}
      />
      <FilterSelect
        model="interventionTemplates"
        onChange={(value) => setFilters("intervention_template_id", value)}
      />
      <FilterSelect
        model="assets"
        onChange={(value) => setFilters("asset_id", value)}
      />
      <FilterSelect
        model="locations"
        onChange={(value) => setFilters("asset.location_id", value)}
      />
      <FilterSelect
        model="organizations"
        onChange={(value) => setFilters("organization_id", value)}
      />
      <FilterSelect
        model="projects"
        onChange={(value) => setFilters("project_id", value)}
      />
      <FilterSelect
        model="recommendations"
        onChange={(value) => setFilters("recommendation_id", value)}
      />
      <ExportButton model="interventions" params={params} />
    </Form>
  );
};

export default ExportIntervention;
